import React from "react";

export const MsgLabel = ({ msg = "" }) => {
  return (
    // 눈에 띄는 에러 메시지를 표시하기 위해 전역으로 사용하는 컴포넌트
    <div className={`py-1 ps-0 container-fluid text-danger ${msg ? "" : "d-none"}`}>{msg}</div>
  );
};
